




















































































import {Component, Vue, Prop} from 'vue-property-decorator';
import store from '@/services/store';
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";
import moment from "moment";

@Component({
    components: {}
})
export default class CSpfAddItemModal extends AlterationI18nMixin {
    @Prop({
        required: true,
        default: false
    })
    private show!: boolean;

    @Prop({
        required: false,
        default: []
    })
    private dataTable!: any[];

    @Prop({
        required: false,
        default: null
    })
    private abpProp!: any[];

    @Prop({
        required: false,
        default: null
    })
    private requestDate!: string | null;
    private is_loading_bip = false;

    private showModal = false;

    // ----------------------budgetLevel-----------------
    private budgetLevel: number[] = [];

    private async loadBudgetLevel() {
        this.budgetLevel = [];
        if (!this.usrId) {
            // eslint-disable-next-line no-console
            return;
        }
        let result = [];
        try {
            result = await fetch(encodeURI('/api-py/get-user-budget-level/' + this.usrId)).then(response => response.json());
        } catch (error) {
            this.makeToast('danger', this.setText('errors.budg_level'), (error as Error).toString());
            return;
        }
        for (const el of result) {
            // eslint-disable-next-line @typescript-eslint/camelcase
            const indx = el.budget_level.lastIndexOf('_');
            if (indx >= 0) {
                this.budgetLevel.push(parseInt(el.budget_level.substr(indx + 1)));
            }
        }
        if (this.budgetLevel.length === 0) {
            this.makeToast('warning', this.setText('attention'), this.setText('no_budg_lvl'));
        }
        await this.loadSpf();
    }

    private get is_ready_to_add() {
        /*if (this.curProg !== null) {
            if (this.curProg.develop_type === 1) {
                if (this.curBip === null) {
                    return false;
                }
            }
        }*/
        return true;
    }

    private get usrId() {
        if (store.state.user.sub === undefined) {
            return null;
        }
        return store.state.user.sub;
    }

    // ------------------ администратор программ ------------------
    private abpBase: any[] = [];
    private curAbp: any | null = null;


    private get abp(): any[] {
        const res: any[] = [];
        for (const el of this.abpBase) {
            res.push(this.setNameLang(el, 'abp'));
        }

        if (this.curAbp !== null) {
            this.curAbp = this.setNameLang(this.curAbp, 'abp');
        }
        return res;
    }

    // ----------------Программа
    private progBase: any[] = [];
    private curProg: any | null = null;

    private get prog(): any[] {
        const res: any[] = [];
        for (const el of this.progBase) {
            res.push(this.setNameLang(el, 'prg'));
        }
        if (this.curProg !== null) {
            this.curProg = this.setNameLang(this.curProg, 'prg');
        }
        return res;
    }

    private chgProg() {
        this.bipBase = [];
        this.curSpf = [];
        this.loadSubProg();
    }
    private async loadProg() {
        let response: any = [];
        this.progBase = [];
        if (response.length === 0 && this.curAbp !== null) {
            try {
                const params = {abp: this.curAbp.abp, type: 4, date: moment(this.requestDate).format('YYYY-MM-DD')};
                response = await fetch(`/api-py/get-dict-func-childs-by-parents-code/${encodeURI(JSON.stringify(params))}`);
                response = await response.json();
            } catch (error) {
                this.makeToast('danger', this.setText('errors.prg'), (error as Error).toString());
            }
        }

        response.sort((a: any, b: any) => (a.prg - b.prg > 0) ? 1 : -1);
        this.progBase = this.setIdArr(response, 'prg');

        if (this.progBase.length > 0) {
            this.curProg = this.progBase[0];
        } else {
            this.curProg = null;
        }
        this.chgProg();
    }

    // ----------------------------подпрограмма------------------------
    private subProgBase: any[] = [];
    private curSubProg: any | null = null;

    private get subProg(): any[] {
        const res: any[] = [];
        for (const el of this.subProgBase) {
            res.push(this.setNameLang(el, 'ppr'));
        }
        if (this.curSubProg !== null) {
            this.curSubProg = this.setNameLang(this.curSubProg, 'ppr');
        }
        return res;
    }

    private async loadSubProg() {
        let response: any = [];
        this.subProgBase = [];
        if (this.curProg !== null) {
            try {
                const params = {abp: this.curAbp.abp, prg: this.curProg.prg, type: 5, date: moment(this.requestDate).format('YYYY-MM-DD')};
                response = await fetch(`/api-py/get-dict-func-childs-by-parents-code/${encodeURI(JSON.stringify(params))}`);
                response = await response.json();
            } catch (error) {
                this.makeToast('danger', this.setText('errors.ppr'), (error as Error).toString());
                response = [];
            }
        }

        response.sort((a: any, b: any) => (a.ppr - b.ppr > 0) ? 1 : -1);
        // eslint-disable-next-line @typescript-eslint/camelcase
        // if (response.length) {
        //     response.unshift({name_ru: 'Все'});
        // }
        this.subProgBase = this.setIdArr(response, 'ppr');

        if (this.subProgBase.length > 0) {
            this.curSubProg = this.subProgBase[0];
        } else {
            this.curSubProg = null;
        }
    }

    // --- spf
    private spfBase: any[] = [];
    private curSpf: any[]  = [];
    private isLoadingSpf = false;

    private get spfDict(): any[] {
        const result: any[] = [];
        for (const el of this.spfBase) {
            result.push(this.setNameLang(el, 'spf'));
        }
        return result;
    }

    private async loadSpf() {
        this.spfBase = [];
        let response: any = [];
        this.curSpf = [];
        this.isLoadingSpf = true;
        try {
            response = await fetch(`/api-py/dict-ebk-spf-add-modal/{${moment(this.requestDate).format('YYYY-MM-DD')}}`);
            response = await response.json();
        } catch (error) {
            this.makeToast('danger', this.setText('errors.spf'), (error as Error).toString());
            response = [];
        }
        this.spfBase = response;
        response.sort((a: any, b: any) => (a.spf - b.spf > 0) ? 1 : -1);
        // if (this.spfDict.length) {
        //     this.curSpf = [this.setNameLang(this.spfBase[0], 'spf')];
        // }
        this.isLoadingSpf = false;
    }

    // --- spf
    private bipBase: any[] = [];
    private curBip: any | null = null;

    private get bipDict(): any[] {
        const result: any[] = [];
        for (const el of this.bipBase) {
            result.push(this.setNameLang(el, 'bip_code'));
        }
        return result;
    }

   /* private async loadBip() {
        this.bipBase = [];
        const request = {
            variant: this.variant,
            abp: this.curAbp.abp,
            prg: this.curProg.prg,
            ppr: this.curSubProg.ppr,
            spf: this.curSpf.spf,
            year: this.year
        }
        let response: any = [];
        this.curBip = null;
        try {
            this.is_loading_bip = true;
            response = await fetch(`/api-py/get-bip-list/`, {
                method: 'POST',
                body: JSON.stringify(request)
            });
            response = await response.json();
        } catch (error) {
            this.makeToast('danger', 'Ошибка загрузки бип', (error as Error).toString());
            response = [];
            this.is_loading_bip = false;
        }
        this.bipBase = response;
        this.is_loading_bip = false;
        if (this.bipDict.length) {
            this.curBip = this.setNameLang(this.bipBase[0], 'bip_code');
        }
    } */

    // ---------------------------------------------

    private setNameLang(obj: any, codeName?: any | null): any {
        let txt = obj['name_' + this.$i18n.locale];
        if (txt === undefined) {
            txt = obj.name_ru;
        }
        if (codeName !== undefined && codeName !== null && obj[codeName] !== undefined) {
            txt = obj[codeName] + ' - ' + txt;
        }
        const el = Object.assign({}, obj);
        el.name = txt;
        return el;
    }

    private mounted() {
        this.chgAbp();
        this.loadBudgetLevel();
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;
        this.$watch('show', function () {
            if (that.show) {
                that.showModal = that.show;
                if (that.budgetLevel.length === 0) {
                    that.loadBudgetLevel();
                }
            }
            that.$emit('shown');
        });

        this.$watch('abpProp', () => {
            this.chgAbp();
        }, { deep: true });
    }

    private chgAbp() {
        this.curAbp = this.abpProp;
        this.loadProg();
    }


    private setIdArr(arr: any[], codeName: string) {
        const result: any[] = [];
        for (const el of arr) {
            if (result.length > 0 && el[codeName] === result[result.length - 1][codeName]) {
                result[result.length - 1].idArr.push(el.id);
            } else {
                result.push(Object.assign({idArr: [el.id]}, el));
            }
        }
        return result;
    }

    private addClk() {
        let curPpr = null;
        let curPprName = null;
        let curPprNameRu = null;
        let curPprNameEn = null;
        let curPprNameKk = null;
        let curGr = this.curProg.gr;
        if (this.curSubProg) {
            curPpr =  this.curSubProg.ppr;
            curPprName =  this.curSubProg.name;
            curPprNameRu =  this.curSubProg.name_ru;
            curPprNameEn =  this.curSubProg.name_ru;
            curPprNameKk =  this.curSubProg.name_kk;
            curGr = this.curSubProg.gr;
        }

        for (const elSpf of this.curSpf) {
            // for (let i =0; i < this.dataTable.length; i++) {
            //     const el = this.dataTable[i];
            //     if (el.abp === this.curAbp.abp && el.prg === this.curProg.prg && el.ppr === curPpr && el.spf === elSpf.spf) {
            //         makeToast(this, 'warning', this.setText('add_elem'), this.setText('already_exists'));
            //         return;
            //     }
            // }
            const resObj: any = {
                abp: this.curAbp.abp,
                gr: curGr,
                abp_name: this.curAbp.name,
                abp_name_ru: this.curAbp.name_ru,
                abp_name_en: this.curAbp.name_ru,
                abp_name_kk: this.curAbp.name_kk,
                prg: this.curProg.prg,
                prg_name: this.curProg.name,
                prg_name_ru: this.curProg.name_ru,
                prg_name_en: this.curProg.name_ru,
                prg_name_kk: this.curProg.name_kk,
                ppr: curPpr,
                ppr_name: curPprName,
                ppr_name_ru: curPprNameRu,
                ppr_name_en: curPprNameEn,
                ppr_name_kk: curPprNameKk,
                spf: elSpf.spf,
                name_ru: elSpf.name_ru,
                name_en: elSpf.name_ru,
                name_kk: elSpf.name_kk,
                expense_code: null,
                child_list: []
            };
            for (let m = 0; m < 12; m++) {
                resObj[`month${m}`] = 0;
                resObj[`month_${m}`] = 0;
            }
            this.$emit('addItemClk', [resObj]);
            this.showModal = false;
        }
    }
}
